import { Button } from "@components/shadcn-ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@components/shadcn-ui/dialog";
import { toast } from "@customHooks/useToast";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Action } from "features/Permission/types";
import { applicationService } from "features/createApplication/service/applicationService";

interface Application {
  id: string;
  leadId: string;
  product: string;
  state: string;
}

interface ReopenApplicationButtonProps {
  application: Application;
}

export function ReopenApplicationButton({
  application,
}: ReopenApplicationButtonProps) {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleReopen = async () => {
    try {
      // Construct the payload. Adjust the structure as needed.
      const payload = {
        id: application.id,
        productType: application.product,
      };

      await applicationService.performAction(
        payload,
        Action.REOPEN_APPLICATION,
        application.leadId
      );

      toast({
        variant: "default",
        description: "Application has been reopened successfully!",
      });
      navigate("/dashboard/applications");
      setDialogOpen(false);
    } catch (error) {
      toast({
        variant: "destructive",
        description: "Something went wrong... Please try again",
      });
      console.error("Error in reopening application:", error);
    }
  };

  return (
    <Dialog open={isDialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button size="sm">Reopen</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader className="p-4 md:p-0">
          <h2 className="text-center text-lg font-semibold">
            Reopen Application
          </h2>
        </DialogHeader>
        <p className="text-center">
          Are you sure you want to reopen this application?
        </p>
        <DialogFooter className="my-4 md:my-0 flex justify-center flex-row gap-4">
          <Button onClick={handleReopen}>Yes, Reopen</Button>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
